import Qs from "qs";
import { differenceInCalendarDays } from "date-fns";

/**
 * Get the opening size of the date range slider. This is so that when the user presses back or refreshes the page, the
 * slider is positioned correctly.
 * @param initialDateRange Full date range on the slider.
 * @param dateRange        Current date range selected.
 * @returns                Filter range dimensions.
 */
export const getDimensions = (width: number, initialDateRange: [Date, Date], dateRange: [Date, Date]) => {
    // Add 1 when getting the difference between days because we want to include the start and end date in the range.
    // e.g 5th - 1st = 4 days but we want to include 1st, 2nd, 3rd, 4th, 5th which is 5 days.
    const initialDateRangeDays = differenceInCalendarDays(initialDateRange[1], initialDateRange[0]) + 1;
    const dateRangeDays = differenceInCalendarDays(dateRange[1], dateRange[0]) + 1;
    // Add a 100px offset to account for the forward and back buttons.
    const dayWidth = (width - 100) / initialDateRangeDays;
    const offset = differenceInCalendarDays(dateRange[0], initialDateRange[0]);

    return {
        dayWidth,
        sliderWidth: dateRangeDays * dayWidth,
        sliderLeft: dayWidth * offset,
    };
};

/**
 * Stringify the dates that will be added to the URL.
 * @param parameters The URL parameters.
 * @returns The stringified URL parameters.
 */
export const stringifyDates = (parameters: Object) => {
    return Qs.stringify(parameters, { addQueryPrefix: true, arrayFormat: "repeat" });
};
